import { z } from "zod";

import { AllOutlineIcons } from "@/components/icons";

export const iconSchema = z.object({
  type: z.literal("icon"),
  name: z.enum(Object.keys(AllOutlineIcons) as [keyof typeof AllOutlineIcons]),
  strokeColor: z
    .object({
      label: z.string().optional(),
      value: z.enum(["#047857", "#6b7280"]),
    })
    .nullish(),
});
